import { useMemo } from "react";
import type { ProfileData } from "../../types";
import styles from "./styles.module.css";

function getAvatar(avatar: string | undefined) {
  // no avatar
  if (!avatar) return "/player_frame.png";

  // real avatar
  return `${avatar}/m.webp`;
}

type PlayerSearchResultProps = {
  data: ProfileData;
};

export function PlayerSearchResult({ data }: PlayerSearchResultProps) {
  const avatar = useMemo(() => getAvatar(data.avatarUrl), [data]);

  return (
    <div className={styles.container}>
      <img className={styles.avatar} src={avatar} alt={data.name} />
      <div className={styles.name}>{data.name}</div>
    </div>
  );
}

type PlayerResultProps = {
  data: ProfileData;
  resetPlayer: () => void;
};

export function PlayerSection({ data, resetPlayer }: PlayerResultProps) {
  const avatar = useMemo(() => getAvatar(data.avatarUrl), [data]);

  return (
    <div className={styles.user_container}>
      <div className={styles.similar_container}>
        <img className={styles.similar_avatar} src={avatar} alt={data.name} />
        <div className={styles.similar_name}>{data.name}</div>
        <div className={styles.check_icon}></div>
      </div>
      <div className={styles.edit_user} onClick={resetPlayer}>
        Сменить игрока
      </div>
    </div>
  );
}
